export default { tag: 'client@2.12.0' };
